<template>
  <b-modal id="retrieve-password-modal" centered lazy size="xl" title-class="text-center flex-grow-1">
    <template slot="modal-title">
      {{ 'titlePasswordPanel' | translate(labels, 'MachinePassword') }}
    </template>

    <p class="text-center text-black mt-4">
      {{ 'selectPasswordPanel' | translate(labels, 'MachinePassword') }}
    </p>

    <b-form-group class="d-flex justify-content-center mb-0">
      <div class="password-panel-group">
        <div v-for="passwordPanel in passwordPanels"
             :key="passwordPanel.type"
             class="password-panel-item"
             :class="{
               active: selectedPasswordPanel === passwordPanel.type,
               interactive: !loading && selectedPasswordPanel !== passwordPanel.type
             }"
             @click="setSelectedPasswordPanel(passwordPanel.type)"
        >
          <div class="password-panel-image">
            <p><img :src="passwordPanel.image"></p>
          </div>
          <b-form-radio v-model="selectedPasswordPanel"
                        name="region-radio"
                        :value="passwordPanel.type"
                        :disabled="loading"
                        class="d-flex justify-content-center mt-3"
          />
        </div>
      </div>
    </b-form-group>

    <template #modal-footer>
      <div v-if="error" class="text-orange">{{ 'defaultError' | translate(labels, 'CommonErrors') }}</div>
      <div class="text-right d-flex flex-wrap d-md-block w-100">
        <b-button class="mt-2 ml-md-3 order-1 col-12 col-md-auto"
                  variant="outline-primary"
                  @click="closeModal('formModal')"
        >
          {{ 'clearLabel' | translate(labels, 'CommonFunctional') }}
        </b-button>
        <b-button type="submit"
                  variant="primary"
                  :disabled="loading || !selectedPasswordPanel"
                  class="mt-2 ml-md-3 order-0 col-12 col-md-auto d-inline-flex justify-content-center align-items-center"
                  @click="setMachinePassword"
        >
          <b-spinner v-if="loading" small class="mr-2" />
          {{ 'setPanelType' | translate(labels, 'MachinePassword') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {bdService} from '../../../services'
import {MACHINE_SAVE} from '../../../store/mutations'

export default {
  conceptName: ['MachinePassword', 'CommonFunctional', 'MachinePasswordImages', 'CommonErrors'],
  name: 'RetrievePassword',
  data: () => ({
    selectedPasswordPanel: '',
    loading: false,
    error: false
  }),
  computed: {
    ...mapGetters({
      serialNumber: 'getCurrentSerial',
      machinePassword: 'getMachinePassword'
    }),
    passwordPanels() {
      return ['1', '5', '3', '6', '4', '2'] // order display of password panels
        .map(type => ({
          type,
          image: this.getPasswordPanelImage(type)
        }))
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('retrieve-password-modal')
    },
    setSelectedPasswordPanel(passwordPanel) {
      if (this.loading) return
      this.selectedPasswordPanel = passwordPanel
    },
    getPasswordPanelImage(type) {
      if (!this.labels['MachinePasswordImages']) return

      const passwordPanelImages = this.labels['MachinePasswordImages']
      const passwordPanelImage = passwordPanelImages[type]
      const link = /(https?:\/\/[^" ]*)/i
      const imageSrc = passwordPanelImage && passwordPanelImage.match(link)
      if (Array.isArray(imageSrc)) return imageSrc[0]
    },
    async setMachinePassword() {
      this.loading = true
      this.error = false
      const panelToSend = this.selectedPasswordPanel === '6' ? '5' : this.selectedPasswordPanel
      try {
        const {data} = await bdService.updateMachinePassword(this.serialNumber, panelToSend)
        await this.$store.commit(MACHINE_SAVE, {
          sn: this.serialNumber,
          password: data
        })
        this.closeModal()
      } catch (error) {
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../../../scss/grid";
@import "../../../scss/colors";
@import "../../../scss/transitions";

.password-panel {
  &-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  &-item {
    margin: 1rem;
    width: 255px;
    border: 1px solid $black;
    text-align: center;
    padding: 1rem;
    height: 290px;
    width: 255px;
    transition: $transition-base;

    &.active {
      border-color: $orange;
    }

    &.interactive {
      cursor: pointer;

      &:hover {
        box-shadow: 0px 16px 24px 0px $hover-default;
        border-color: $orange;
      }
    }
  }

  &-image {
    height: calc(100% - 30px);
    display: flex;
    align-items: center;
    justify-content: center;

    p,
    span,
    image {
      margin: 0;
      padding: 0;
    }

    img {
      max-width: 100%;
    }
  }
}
</style>
